<template>
<div>
    <v-row>
        <v-col col="12" sm="3" md="2">
            <div class="text-center">
                <v-btn fab depressed class="mt-2 white" :href="it.url">
                    <v-icon :color="getColor">fa-file-download</v-icon>
                </v-btn>
            </div>
        </v-col>

        <v-col col="12" sm="9" md="10" v-if="loaded">
            <div class="subtitle-1 font-weight-medium mt-1" style="line-height:1.1">
                {{it.title}}
            </div>
            <div class="caption grey--text text--darken-1">
                {{it.formattedDate}}
            </div>
            <div class="caption grey--text text--darken-1 mt-n1">
                Uploaded by: {{it.uploadedBy.name}}
            </div>
            <div class="body-2" style="line-height:1.3">
                {{it.description}}
            </div>
            <div style="width:240px">
                <v-divider class="mt-2"></v-divider>
            </div>
            <div class="mt-1">
                <v-btn text class="grey--text text--darken-2 ml-n2" :disabled="count==0" @click="showComments=!showComments">
                    <v-icon small left :color="getColor">fa-comment-dots</v-icon>
                    <span style="font-size:10px" v-if="!showComments">Show Comments ({{count}})</span>
                    <span style="font-size:10px" v-else>Hide comments</span>
                </v-btn>
                <v-btn small depressed class="accent" @click="showDiagComment=true" v-if="!user.role.student">
                    <span style="font-size:10px">Comment</span>
                </v-btn>
            </div>
            <div class="mt-2 grey lighten-4 pa-4" v-if="showComments">
                <div class="mb-1" v-for="(item, index) in comments" :key="item.id">
                    <div class="caption font-weight-medium">Por {{item.user.name}}</div>
                    <div style="font-size:10px">{{item.dateFormatted}}</div>
                    <div class="body-2">{{item.comment}}</div>
                    <div>
                        <v-btn text class="accent--text ml-n4 mt-n1" @click="tryToRemove(item.id)" v-if="!user.role.student">
                            <span style="font-size:10px">Delete</span>
                        </v-btn>
                    </div>
                    <v-icon class="mb-1" color="primary" v-if="index<comments.length-1">fa-minus</v-icon>
                </div>
            </div>
        </v-col>

        <v-col col="12" sm="6" md="8" v-else>
            <SendingLoader />
        </v-col>
    </v-row>

    <DiagComment
        :model="showDiagComment"
        :team="team"
        :fileId="fileId"
        :fileTitle="fileTitle"
        @cancel="showDiagComment=false"
        @added="reinit"
        v-if="loaded" />
    
    <DiagRemove
        :model="showTryRemove"
        text="Are your sure you want to delete the comment?"
        @cancel="showTryRemove=false" 
        @remove="removeComment" />
</div>
</template>

<script>
import Work from '@/firebase/work'
import Helpers from '@/services/helpers'
import FormatDate from '@/services/formatDate'
import DiagComment from '@/components/core/dialogs/DiagComment'
import DiagRemove from '@/components/core/dialogs/DiagRemove'

export default {
    data: () => ({
        loaded: false,
        showDiagComment: false,
        showComments: false,
        showTryRemove: false,
        count: 0,
        team: null,
        fileId: null,
        fileTitle: null,
        actualComment: null,
        comments: []
    }),
    props: ['it', 'fromTeam'],
    components: {
        DiagComment,
        DiagRemove
    },
    computed: {
        getColor() {
            if(this.fromTeam === true) {
                return 'accent';
            } else {
                return this.user.color;
            }
        }
    },
    mounted() {
        this.init();
    },
    methods: {
        reinit() {
            this.showDiagComment = false;
            this.$emit('reinit');
        },
        init() {
            if (this.$route.params.id) {
                this.team = this.$route.params.id;
            } else {
                this.team = this.user.team;
            }
            
            this.fileId = this.it.id;
            this.fileTitle = this.it.title;
            this.getComments();
        },
        getComments() {
            Work.getComments(this.team, this.fileId)
                    .then(response => {
                        if (response.status === true) {
                            this.count = response.query.docs.length;
                            this.comments = Helpers.formatItems(response.query);
                            this.comments = _.orderBy(this.comments, 'date', 'desc');
                            this.comments.forEach(dt => {
                                dt.dateFormatted = FormatDate.getFormatted(dt.date);
                            });
                        } else {
                            this.$store.dispatch('setSnack', {kind:'error', text:'Error.'});
                        }
                        this.loaded = true;
                    });
        },
        tryToRemove(id) {
            this.actualComment = id;
            this.showTryRemove = true;
        },
        removeComment() {
            Work.removeComment(this.team, this.fileId, this.actualComment)
                    .then(response => {
                        if (response === true) {
                            this.$emit('reinit');
                            this.$store.dispatch('setSnack', {kind:'success', text:'Comment deleted.'});
                        } else {
                            this.$store.dispatch('setSnack', {kind:'error', text:'Error.'});
                        }
                        this.loaded = true;
                    });
        }
    }
}
</script>
